<template>
  <div class="pb-3">
    <p class="text-body-tertiary">
      {{ $t("forwards.mandates.escrow_remaining.description") }}
    </p>
    <p v-if="rows.length === 0" class="text-body-tertiary mb-0 py-2">
      {{ $t("forwards.mandates.escrow_remaining.empty") }}
    </p>
    <div v-else class="table-responsive">
      <table class="table align-middle mb-0">
        <thead>
          <tr>
            <th scope="col">
              <span class="eyebrow-label eyebrow-label--sm">{{
                $t("forwards.mandates.escrow_remaining.period")
              }}</span>
            </th>
            <th scope="col">
              <span class="eyebrow-label eyebrow-label--sm">{{
                $t("forwards.mandates.escrow_remaining.escrowed")
              }}</span>
            </th>
            <th scope="col">
              <span class="eyebrow-label eyebrow-label--sm">{{
                $t("forwards.mandates.escrow_remaining.status")
              }}</span>
            </th>
            <th scope="col">
              <span class="eyebrow-label eyebrow-label--sm">{{
                $t("forwards.mandates.escrow_remaining.window_end")
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="`${row.period_label}-${row.commitment_status}-${row.window_end}`"
          >
            <td>{{ row.period_label }}</td>
            <td>
              {{ $t("forwards.common.mwh_value", { value: row.escrowed_mwh }) }}
            </td>
            <td>
              <ForwardsStatusBadgeComponent :status="row.commitment_status" />
            </td>
            <td>
              {{
                row.window_end
                  ? formatDate(row.window_end)
                  : $t("forwards.common.no_window_end")
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatDate } from "@/composables/formatUtils";
import ForwardsStatusBadgeComponent from "@/forwards2/components/ForwardsStatusBadgeComponent.vue";
import type { EscrowRemainingRow } from "@/forwards2/forwardsTypes";

/**
 * The mandate editor's read-only view for a viewer whose only claim on the mandate is escrow it left
 * behind: the response carries nothing else to show, let alone edit.
 */
defineProps<{
  rows: EscrowRemainingRow[];
}>();
</script>
